import { render, staticRenderFns } from "./sharing-image.vue?vue&type=template&id=707c139e&scoped=true&"
import script from "./sharing-image.vue?vue&type=script&lang=js&"
export * from "./sharing-image.vue?vue&type=script&lang=js&"
import style0 from "./sharing-image.vue?vue&type=style&index=0&id=707c139e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c139e",
  null
  
)

export default component.exports